export class RelativeDatePreorderSettingsType {
    constructor(params) {
        this.type = "RelativeDate";
        this.buffer = params.buffer;
        this.maxDays = params.maxDays;
    }
    max(other) {
        return new RelativeDatePreorderSettingsType({
            buffer: this.buffer.min(other.buffer),
            maxDays: Math.max(this.maxDays, other.maxDays),
        });
    }
    toString() {
        var _a;
        return `${this.type}[addWorkdays=${(_a = this.buffer.addWorkdays) !== null && _a !== void 0 ? _a : "null"},maxDays=${this.maxDays}]`;
    }
}
